<template>
  <v-dialog v-model="visible" max-width="420">
    <v-card>
      <v-card-title class="headline white--text pb-2" :class="color">
        {{ titulo }}
        <v-icon color="white" class="mr-2">
          {{ icon }}
        </v-icon>
      </v-card-title>

      <v-card-text class="pt-2">
        {{ mensagem }}
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text color="primary" @click="visible = false"> OK </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogMensagem",

  data() {
    return {
      visible: false,
      tipo: "info",
      titulo: "",
      mensagem: "",
    };
  },

  computed: {
    icon() {
      return {
        success: "mdi-check-circle",
        info: "mdi-information",
        warning: "mdi-alert",
        error: "mdi-alert-circle",
      }[this.tipo];
    },
    color() {
      return {
        success: "success",
        info: "info",
        warning: "warning",
        error: "error",
      }[this.tipo];
    },
  },

  methods: {
    show(tipo, titulo, mensagem) {
      this.tipo = tipo || "info";
      this.titulo = titulo;
      this.mensagem = mensagem;
      this.visible = true;
    },
  },
};
</script>
